/* Publish by EComposer at 2026-10-08 02:12:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dpuy5mjfh1p"]=  window.__ectimmers["ecom-dpuy5mjfh1p"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-dpuy5mjfh1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpuy5mjfh1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23egyd8iivn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23egyd8iivn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6a7sl0q3rj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6a7sl0q3rj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8me13ogylj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8me13ogylj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cn7lf2gmvnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cn7lf2gmvnh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qd145r5ydem"]=  window.__ectimmers["ecom-qd145r5ydem"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-qd145r5ydem"]["mi7jbkv07"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-qd145r5ydem').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd145r5ydem', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3pl3q41wpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3pl3q41wpg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tqtch8ddcws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqtch8ddcws', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}